import React from 'react';
import { useLocation } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth';

import Button, { EButtonColors } from 'components/Base/Button';
import TextLink, { ETextLinkColors } from 'components/Base/TextLink';
import { Col } from 'components/Base/Grid';
import Divider from 'components/Base/Divider';
import { Icon, TIconNames } from 'components/Base/Icon';
import Image from 'components/Base/Image';
import { Colors, FontWeights } from 'core/CssVariables';
import google from 'assets/google.svg';

import { NotifiableError } from '@bugsnag/js';
import { SDividerText } from './style';
import {
  ELink,
  ELinkText,
  EMode,
  EQuestion,
  EVia,
  TLoginButtonGroupsProps,
} from './type';
import { bugsnagClient } from '../../../ErrorBoundary';
import { useClearImpersonationData } from '../../../hooks/useClearImpersonationData';

const LoginButtonGroups = ({ mode, onClick }: TLoginButtonGroupsProps) => {
  const location = useLocation();
  const removeImpersonationData = useClearImpersonationData();
  const hideViaPhoneBtn = false;
  return (
    <Col>
      <Button
        color={EButtonColors.Info}
        className="w-100"
        onClick={() => {
          localStorage.setItem('viaEmail', 'true');
          removeImpersonationData();
          Auth.federatedSignIn({
            provider: CognitoHostedUIIdentityProvider.Google,
          }).catch(err => bugsnagClient?.notify(err as NotifiableError));
        }}
      >
        <Image src={google} alt="google-log" className="mr-3" />
        Continue with Google
      </Button>
      <Divider className="mt-8 mb-8">
        <SDividerText>or</SDividerText>
      </Divider>
      {!hideViaPhoneBtn && (
        <Button
          outlined
          className="w-100"
          onClick={() => onClick(EVia.PHONE)}
          icon={
            <Icon
              color={Colors.Black}
              icon={TIconNames.MOBILE_PHONE}
              size={16}
            />
          }
        >
          {EMode[mode]} via phone
        </Button>
      )}

      <Button
        className="w-100 mt-4 mb-6"
        onClick={() => onClick(EVia.EMAIL)}
        icon={
          <Icon color={Colors.Black} icon={TIconNames.ENVELOPE} size={16} />
        }
      >
        {EMode[mode]} via email
      </Button>
      <TextLink
        className="mt-10"
        linkText={ELinkText[mode]}
        to={{ pathname: `${ELink[mode]}`, search: location.search }}
        type={ETextLinkColors.BLACK}
        fontLevel={5}
        fontWeight={FontWeights.Medium}
      >
        {EQuestion[mode]}
      </TextLink>
    </Col>
  );
};

export { EVia };

export default LoginButtonGroups;
